import React from "react";
import { Icon, Menu } from "antd";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { claimList, readNotificationClaim, readAllNotificationsClaim } from "../../Services/ClaimCashless";
import { useNotificationsClaimPending } from "../../Hook/hookNotifClaim";
import { useEffect } from "react";
import AllDataUser from "../../Hook/hookData";
import bilingual from "../../Helper/bilingual";
import i18next from "i18next";

const NotificationMenu = ({ dataClaimPending, onItemClick }) => {
  const { user, lang } = AllDataUser();
  bilingual(lang);

  const pendingItems = Array.isArray(dataClaimPending?.data?.data)
    ? dataClaimPending.data.data
    : Array.isArray(dataClaimPending?.data?.data?.data)
    ? dataClaimPending.data.data.data
    : Array.isArray(dataClaimPending?.data)
    ? dataClaimPending.data
    : [];

  const handleItemClick = (claimId) => {
    const userId = user?.user_id;
    if (claimId && userId) {
      readNotificationClaim(claimId, userId).catch((err) => {
        console.error("Failed to mark claim notification as read:", err);
      });
    }
    if (onItemClick) {
      onItemClick();
    }
  };

  const handleShowAllClick = () => {
    const userId = user?.user_id;
    if (userId) {
      readAllNotificationsClaim(userId).catch((err) => {
        console.error("Failed to mark all notifications as read:", err);
      });
    }
    if (onItemClick) {
      onItemClick();
    }
  };

  return (
    <Menu
      className="notification-menu"
      style={{ width: 350, padding: 10, border: "1px solid #e8e8e8" }}
    >
      <Menu.ItemGroup
        title={
          <div
            style={{
              fontWeight: "bold",
              fontSize: 14,
              padding: "5px 10px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            {i18next.t("NotifNew")}
          </div>
        }
      />

      {/* List item notifikasi */}
      {(dataClaimPending?.finish && dataClaimPending?.error && (
        <div
          style={{
            fontSize: 12,
            color: "red",
            textAlign: "center",
            margin: 20,
          }}
        >
          {dataClaimPending?.data?.data?.desc || "Error loading notification"}
        </div>
      )) ||
        (dataClaimPending?.finish &&
          !dataClaimPending?.error &&
          pendingItems.map((n, idx) => {
            const claimId = n.RocNo || n.claim_id || n.id;
            return (
              <Menu.Item
                key={claimId}
                style={{
                  whiteSpace: "normal",
                  lineHeight: "1.4em",
                  padding: "10px 8px",
                  height: "max-content",
                }}
              >
                <Link
                  to={{
                    pathname: `/claim/${n.RocNo || claimId}`,
                    state: { type: "claim", data: n },
                  }}
                  onClick={() => handleItemClick(claimId)}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <Icon
                    type={"notification"}
                    style={{
                      fontSize: 20,
                      color: "#ff5722",
                      marginRight: 10,
                      marginTop: 3,
                    }}
                  />
                  <div>
                    <div
                      style={{ fontWeight: "bold", color: "#333" }}
                    >{`${i18next.t("ClaimNo")} ${n.RocNo}`}</div>
                    <div style={{ fontSize: 12, color: "#666" }}>
                      {n.Remark}
                    </div>
                    <div style={{ fontSize: 12, color: "#666" }}>
                      {(!n.Reason && "-") || n.Reason}
                    </div>
                  </div>
                </div>
              </Link>
            </Menu.Item>
          );
        }))}

      <Menu.Divider />

      {/* Footer link */}
      <Menu.Item key="all" onClick={handleShowAllClick} style={{ textAlign: "center", fontWeight: "bold" }}>
        <Link to="/notification/claim" onClick={handleShowAllClick}>{i18next.t("ShowAll")}</Link>
      </Menu.Item>
    </Menu>
  );
};

export default NotificationMenu;
